import React, { useContext, useEffect } from 'react';
import './App.scss';
import PageRouter from './components/PageRouter';
import honeycomb_1 from './assets/img/honeycomb-1.svg'
import honeycomb_2 from './assets/img/honeycomb-2.svg'
import { addHeaderLoadedListener, removeHeaderLoadedListener } from 'services/eventFunctions';
import Loader from 'components/Loader';
import PageContext from 'global_state/context/PageContext';


function App() {

  const {page, dispatchPage} = useContext(PageContext)

  const renderContent = () => {
    // console.log(process.env.REACT_APP_LOCAL);
    
    if (page.header_loaded || process.env.REACT_APP_LOCAL == 'true') {
      return <PageRouter/>
    }

    return <Loader/>
  }
  useEffect(() => {
    const gopay_script = document.createElement("script");
    gopay_script.src = "https://gw.sandbox.gopay.com/gp-gw/js/embed.js";
    gopay_script.type = "text/javascript"
    gopay_script.async = true;
    
    document.body.appendChild(gopay_script);

    addHeaderLoadedListener(dispatchPage)

    return () => {
      removeHeaderLoadedListener(dispatchPage)
    }

  }, [])

  return (
    <div className="app">
      <div className="app_background">
        <div className="app_background_images">
          <div className='image'>
            <img src={honeycomb_1} alt="" />
          </div>
          <div className='image'>
            <img src={honeycomb_2} alt="" />
          </div>
          
        </div>
        <div className="app_content">
            {renderContent()}
        </div>  
      </div>
      
    </div>
  )
}

export default App;
